import TalentNavbar from './TalentNavbar';
export type { TalentNavbarProps } from './TalentNavbar';
export { default as TalentPageTitle } from './TalentPageTitle';
export default TalentNavbar;
